
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>
    <b-card title="Informations générales">
     <!-- form -->
      <validation-observer ref="loginValidation">
        <b-form
          class="auth-user-form mt-2"
          @submit.prevent
        >
    
      <b-row>
         <b-col
          md="6"
          xl="4"
          class="mb-1"
        >
          <b-form-group
            label="Nom"
            label-for="basicInput"
          >
          <validation-provider
                  #default="{ errors }"
                  name="Nom"
                  rules="required"
                >
            <b-form-input
             required
              id="basicInput"
              v-model="form.name"
              :plaintext="readOnly"
              placeholder="Nom"
             
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="6"
          xl="4"
          class="mb-1"
        >
          <b-form-group
            label="Prénom"
            label-for="basicInput"
          >
          <validation-provider
                  #default="{ errors }"
                  name="Prénom"
                  rules="required"
                >
            <b-form-input
             required
              id="basicInput"
              v-model="form.surname"
              :plaintext="readOnly"
              placeholder="Prénom"
             
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          md="6"
          xl="4"
          class="mb-1"
        >
        
          <b-form-group
            label="Email"
            label-for="basicInput"
          >
          <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
            <b-form-input
             
              id="basicInput"
              type="email"
              v-model="form.email"
              :state="errors.length > 0 ? false:null"
              :plaintext="readOnly"
              placeholder="Email"
             
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          </b-form-group> 
        </b-col>
        
      </b-row>
     
 
      <b-row>
        <b-col v-if="readOnly==false && edition == false"
          md="6"
          xl="4"
          class="mb-1"
        >
          <b-form-group 
            label="Mot de passe"
            label-for="basicInput"
          >
          <validation-provider
                  #default="{ errors }"
                  name="Mot de passe"
                  rules="required"
                >
            <b-form-input
             required
              id="basicInput"
              type="password"
              v-model="form.password"
              :plaintext="readOnly"
              placeholder="Password"
             
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Compte principal"
              label-for="Type"
            >
            <v-select
                v-model="form.main_user"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
              
                
                :options="mainUserChoices"
              />
             
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Type de compte"
              label-for="Type"
            >
            <v-select
                v-model="type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
              
                
                :options="typeChoices"
              />
             
            </b-form-group>
          </b-col>

      </b-row>
      <div v-if="readOnly==false">
       <b-button v-if="edition==false"
        @click="createUser"
        >
        Enregistrer
        </b-button>
        <b-button v-else
        @click="updateUser"
        >
        Enregistrer
        </b-button>
        
      </div>
      </b-form>
          </validation-observer>
    </b-card>
  </div>
</b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BButton,BFormInput, BOverlay, BRow, BCol, BFormGroup,BFormFile, BCard, BFormCheckbox, BFormTextarea, BForm} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { required, email } from '@validations'
import vSelect from 'vue-select'
import store from '@/store/index'
import {APIRequest, Auth, Utils} from '@simb2s/senseye-sdk'

export default {
  name: 'UserForm',
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormFile,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    BForm
  },
  data() {
      return {
        
          edition:false,
          loading:true,
          
          mainUserChoices:[],
          type:null,
          typeChoices:['fournisseur','sous-compte'],
          validation: true,
          form:{
            name:"",
           
            surname: "",
            main_user:null,
            username:"",
       
            email:"",
            password: ""
          },
          required
      }
  },
  props: ['user', 'readOnly'],
  methods:{
   
    async getMainUsers() {

      let mainUsers=await Auth.list_users_by_role('ROLE_BRAND')
      for(let i=0;i<mainUsers.length;i++) {
        if(mainUsers[i].main_user!=null) {
          mainUsers.splice(i, 1);
          i--
        }
      }
      this.mainUserChoices=Utils.formatSelect(mainUsers,'brand_name','id')
      
    },
      async createUser()
      {
        this.$refs.loginValidation.validate().then(async success => {
        if (success) {
          this.loading=true
           try{
              // $check_surname = await Auth.get_user(this.form.surname)
              let checkuser = await Auth.get_user(this.form.email)
              
              if(!checkuser){

               
                var main_user=this.form.main_user
                
               
           
                this.form.username=this.form.email

                let datas=this.form
                if(main_user!=null)
                {
                  console.log(main_user)
                  
                  datas.main_user={}
                  datas.main_user.id=main_user.value
                  
                }

                try {
                  let $register
                if(this.type=='fournisseur')
                {
                  $register = await APIRequest.post_request("register-factory",datas)
                }
                else
                {
                  $register = await APIRequest.post_request("register-sub-account",datas)
                }


                

                if($register && $register.status == 200){

                  this.$toast({
                      component: ToastificationContent,
                      props: {
                          title: 'L\'utilisateur B2B a bien été créé !',
                          icon: 'CheckIcon',
                          variant: 'success',
                      },
                  })
                  this.$router.push({name:'users-sub-accounts'})
                }
                }
                catch(error)
                {
                  this.loading=false
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Erreur lors de la création de l\'utilisateur !',
                      icon: 'AlertCircleIcon',
                      variant: 'danger',
                    },
                  })
                  console.log(error)
                }
               
              }
              else{
                this.loading=false
                
              }
           }
           catch(error)
           {
             this.loading=false
             
           }

        }
        })
      },
     
      async updateUser()
      {
        this.$refs.loginValidation.validate().then(async success => {
        if (success) {
          this.loading=true
           try{
              // $check_surname = await Auth.get_user(this.form.surname)
              

                var color_categories=this.form.color_categories
                this.form.color_categories=[]
                if(color_categories!=null)
                {
                  for(var i=0;i<color_categories.length;i++)
                  {
                    this.form.color_categories[i]={}
                    this.form.color_categories[i].id=color_categories[i].value
                  }
                }
           
                this.form.username=this.form.email
                await Auth.update_account(this.user.id,this.form)

               

                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'L\'utilisateur B2B a bien été modifié !',
                        icon: 'CheckIcon',
                        variant: 'success',
                    },
                })
                this.$router.push({name:'users-b2b'})
                
              
           }
           catch(error)
           {
             this.loading=false
             
           }

        }
        })
      },
      
  },
  async mounted(){
    await this.getMainUsers();
    if(this.user!=null)
    {
      this.form = this.user
    
   
      this.file=this.user.brand_logo
    
    
      if(this.user.color_categories!=null)
      {
        let color_categories=[]
        for(let i=0;i<this.user.color_categories.length;i++)
        {
          color_categories.push({value:this.user.color_categories[i].id,title:this.user.color_categories[i].name})
        }
        this.form.color_categories=color_categories
      }
      this.edition=true
    }
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>